import { createPaymentOrder, verifyPayment } from "./api";
import { toast } from "sonner";

let scriptPromise = null;
function loadRazorpay() {
  if (window.Razorpay) return Promise.resolve(true);
  if (scriptPromise) return scriptPromise;
  scriptPromise = new Promise((resolve) => {
    const s = document.createElement("script");
    s.src = "https://checkout.razorpay.com/v1/checkout.js";
    s.onload = () => resolve(true);
    s.onerror = () => resolve(false);
    document.body.appendChild(s);
  });
  return scriptPromise;
}

/**
 * Starts the Razorpay checkout for a self-serve plan.
 * onNotConfigured() is called when the gateway keys aren't set yet, so the
 * caller can fall back to the callback/enquiry flow.
 */
export async function startPlanCheckout({ planId, prefill = {}, onSuccess, onNotConfigured }) {
  let order;
  try {
    const res = await createPaymentOrder({ plan_id: planId, ...prefill });
    order = res.data;
  } catch (err) {
    const status = err?.response?.status;
    if (status === 503) {
      onNotConfigured?.();
      return;
    }
    toast.error(err?.response?.data?.detail || "Could not start payment. Try again.");
    return;
  }

  const ok = await loadRazorpay();
  if (!ok) {
    toast.error("Payment gateway failed to load. Check your connection.");
    return;
  }

  const rzp = new window.Razorpay({
    key: order.key_id,
    amount: order.amount,
    currency: order.currency,
    order_id: order.order_id,
    name: "Unicators",
    description: `${order.plan_name} Plan — Self-Serve Subscription`,
    theme: { color: "#6043EF" },
    prefill: {
      name: prefill.name || "",
      email: prefill.email || "",
      contact: prefill.phone || "",
    },
    handler: async (resp) => {
      try {
        await verifyPayment({
          razorpay_order_id: resp.razorpay_order_id,
          razorpay_payment_id: resp.razorpay_payment_id,
          razorpay_signature: resp.razorpay_signature,
        });
        toast.success("Payment successful! Our team will activate your access shortly.");
        onSuccess?.(resp);
      } catch {
        toast.error("Payment captured but verification failed. We'll reach out to confirm.");
      }
    },
  });
  rzp.on("payment.failed", () => toast.error("Payment failed or cancelled."));
  rzp.open();
}
